import React, { createContext, useState, useContext } from 'react';

const PreRegContext = createContext();

export const PreRegProvider = ({ children }) => {
  const [contextPreReg, setContextPreReg] = useState(null);
  return (
    <PreRegContext.Provider value={{ contextPreReg, setContextPreReg }}>
      {children}
    </PreRegContext.Provider>
  );
};

export const usePreReg = () => useContext(PreRegContext);